var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBell = function SvgBell(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "12qt6rhewa",
    d: "M.187.03l6.64 1.32C6.23 2.87 4.613 3.793 2.954 3.463 1.297 3.133.157 1.663.187.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "51pbcnf8lc",
    d: "M19.049 18.56c.744.766 1.065 1.849.856 2.897l-.251 1.263L.24 18.859l.251-1.263c.209-1.048.92-1.927 1.9-2.35.614-.264 1.058-.813 1.188-1.468l1.218-6.121c.746-3.752 4.13-6.307 7.84-6.12l.135-.677c.11-.55.644-.907 1.194-.797.55.109.907.643.797 1.193l-.13.651c3.614 1.18 5.857 4.9 5.097 8.72l-1.218 6.121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "qfda41p75e",
    d: "M16.707 9.258c-2.11 3.847-6.198 6.454-10.895 6.454-2.022 0-3.932-.484-5.62-1.342.102-.182.176-.382.218-.592l1.217-6.121c.747-3.752 4.131-6.307 7.84-6.12L9.604.86c.096-.483.52-.817.994-.817.066 0 .132.006.2.02.55.109.906.643.797 1.193l-.13.651c3.18 1.037 5.297 4.042 5.243 7.351"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-37 -531) translate(36 530) translate(0 .14) translate(7.133 20.872)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "w5dpy4phmb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#12qt6rhewa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9CAFD0",
    d: "M.187.03c-.03 1.633 1.11 3.103 2.768 3.433 1.659.33 3.275-.592 3.871-2.113L.187.03z",
    mask: "url(#w5dpy4phmb)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-37 -531) translate(36 530) translate(0 .14) translate(.793 .793)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "r4i0dtuw1d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#51pbcnf8lc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C2D1EA",
    d: "M19.049 18.56c-.466-.48-.666-1.157-.536-1.812l1.218-6.121c.76-3.82-1.483-7.54-5.096-8.72l.13-.651c.109-.55-.248-1.084-.798-1.193-.55-.11-1.084.247-1.194.797l-.135.678c-3.71-.188-7.094 2.367-7.84 6.119L3.58 13.778c-.13.655-.574 1.204-1.187 1.468-.982.423-1.692 1.302-1.9 2.35L.24 18.859l19.413 3.86.251-1.262c.209-1.048-.112-2.131-.856-2.898",
    mask: "url(#r4i0dtuw1d)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-37 -531) translate(36 530) translate(3.963 .933)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "var(--blue)",
    d: "M4.153.19c2.243 0 4.06 1.818 4.06 4.06 0 2.243-1.817 4.06-4.06 4.06-2.242 0-4.06-1.817-4.06-4.06 0-2.242 1.818-4.06 4.06-4.06",
    transform: "translate(-37 -531) translate(36 530) translate(15.588 1.725)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M4.306 2.22c.21 0 .38.17.38.38v2.183c0 .21-.17.381-.38.381s-.38-.17-.38-.38V2.6c0-.21.17-.38.38-.38M4.306 5.671c.21 0 .38.17.38.38 0 .211-.17.382-.38.382s-.38-.17-.38-.381c0-.21.17-.38.38-.38",
    transform: "translate(-37 -531) translate(36 530) translate(15.588 1.725)"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBell, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bell.7f26b6fe.svg";
export { ForwardRef as ReactComponent };